/**
 * Storefront widget templates — used for right-side preview + template picker.
 * Modes: month = classic grid; list = vertical events; grid = image-style tiles.
 */
export const WIDGET_TEMPLATES = [
  {
    id: "classic-forest",
    label: "Classic month",
    description: "Month grid, green header (ref: classic calendar).",
    mode: "month",
    accent: "#0f7a4b",
  },
  {
    id: "brunch-light",
    label: "Soft list",
    description: "List view with large titles.",
    mode: "list",
    accent: "#4f6bed",
  },
  {
    id: "masonry",
    label: "Card grid",
    description: "2-column event cards with image strip.",
    mode: "grid",
    accent: "#6b21a8",
  },
  {
    id: "minimal-ink",
    label: "Minimal month",
    description: "Plenty of whitespace, thin lines.",
    mode: "month",
    accent: "#0f172a",
  },
  {
    id: "sunset-week",
    label: "Strip week",
    description: "Horizontal week + dots under dates.",
    mode: "week",
    accent: "#c2410c",
  },
  {
    id: "navy-grid",
    label: "Navy month",
    description: "Dark header, light body.",
    mode: "month",
    accent: "#0b1f3a",
  },
];

export function getTemplateById(id) {
  return WIDGET_TEMPLATES.find((t) => t.id === id) || WIDGET_TEMPLATES[0];
}
